var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icons",class:_vm.classes},_vm._l((_vm.icons),function(width,index){return _c('span',{key:index,staticClass:"icon"},[_c('span',{staticClass:"icon-fill",style:({ width: width + '%' })})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }